import { resolveFillerPlaylist } from './fillerPlaylist';

export function isCirculoHexColor(value: unknown): value is string {
  return typeof value === 'string' && /^#[0-9a-fA-F]{6}$/.test(value);
}

export function resolveCirculoBackground(config: object): 'playlist' | 'image' | 'color' | 'blur' {
  const bag = config as {
    fillerUrl?: string;
    fillerUrls?: string[];
    backgroundUrl?: string;
    backgroundColor?: string;
  };

  if (resolveFillerPlaylist(bag).length > 0) return 'playlist';

  if (bag.backgroundUrl) return 'image';

  if (isCirculoHexColor(bag.backgroundColor)) return 'color';

  return 'blur';
}
